// @todo: effort minimal sur ce mapper, du fait que le Content Model est voué à disparaître au profit de Common Item.

import { ContentModelId } from '../../../../../types/ContentModelId'
import type { FaqBlock } from '../../../domain/FaqBlock'
import type { FaqBlockDTO } from '../../../domain/FaqBlockDTO'

import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

export const mapFaqBlockFromApi = (dto: FaqBlockDTO): FaqBlock | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { content: description, title } = dto.fields

  return {
    contentType: ContentModelId.FAQ_BLOCK,
    description,
    title,
  }
}
